import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Login from './LoginPage';

const BQ_BASE_URL = process.env.REACT_APP_BQ_BASE_URL;

const fallbackImage = 'https://via.placeholder.com/1920x1080?text=Welcome+to+Royal+Garden+Hotel';

const Home = () => {
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [bgMedia, setBgMedia] = useState({ url: '', type: 'image' });
  const [propertyName, setPropertyName] = useState('Pagoda Executive'); // Direct state for property name

  const closeLoginModal = () => {
    setShowLoginModal(false);
    setTimeout(() => {
      window.location.reload();
    }, 500);
  };

  const handleExploreClick = () => {
    const token = Cookies.get('access_token');

    if (!token) {
      toast.error('You are not logged in. Please log in to continue.', {
        position: 'bottom-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: 'colored',
      });

      setTimeout(() => {
        setShowLoginModal(true);
      }, 1000);
    } else {
      window.location.href = '/check-in/options';
    }
  };

  useEffect(() => {
    const fetchHomepageData = async () => {
      const cachedData = localStorage.getItem('homepageData');
      const cachedTime = localStorage.getItem('homepageDataTimestamp');
      const oneHour = 60 * 60 * 1000;

      if (cachedData && cachedTime && Date.now() - cachedTime < oneHour) {
        const parsedData = JSON.parse(cachedData);
        setBgMedia(parsedData.media);
        setPropertyName(parsedData.propertyName); // Use propertyName from cache
        return;
      }

      try {
        const response = await fetch(`${BQ_BASE_URL}/bq/api/properties/1`);
        if (!response.ok) throw new Error('Failed to fetch property data');
        const data = await response.json();

        console.log('API Response:', data); // For debugging

        // Prepare data for state and storage
        const mediaData = data.homepage_video_url
          ? { url: data.homepage_video_url, type: 'video' }
          : data.homepage_url
            ? { url: data.homepage_url, type: 'image' }
            : { url: fallbackImage, type: 'image' };

        // Set property name directly from API - using 'name' field
        setPropertyName(data.name || 'Pagoda Hotel');

        // Store in localStorage
        const storageData = {
          media: mediaData,
          propertyName: data.name || 'Pagoda Hotel', // Store property name
        };

        // Update state
        setBgMedia(mediaData);

        // Update localStorage
        localStorage.setItem('homepageData', JSON.stringify(storageData));
        localStorage.setItem('homepageDataTimestamp', Date.now().toString());
      } catch (error) {
        console.error('Failed to load homepage data', error);
        if (cachedData) {
          const parsedData = JSON.parse(cachedData);
          setBgMedia(parsedData.media);
          setPropertyName(parsedData.propertyName);
        } else {
          setBgMedia({ url: fallbackImage, type: 'image' });
        }
      }
    };

    fetchHomepageData();
  }, []);

  return (
    <div className="relative flex items-center justify-center h-screen w-screen overflow-hidden">
      {bgMedia.url &&
        (bgMedia.type === 'video' ? (
          <video
            src={bgMedia.url}
            autoPlay
            loop
            muted
            playsInline
            className="absolute inset-0 w-full h-full object-cover opacity-100"
          />
        ) : (
          <img
            src={bgMedia.url}
            alt="Hotel Background"
            className="absolute inset-0 w-full h-full object-cover opacity-100"
          />
        ))}

      <div className="text-center relative z-10 bg-gray-100 p-7 bg-opacity-70 rounded-lg mt-20">
        <h1 className="text-xl md:text-3xl font-bold text-gray-950 mb-2">
          Welcome to <span className="text-black">{propertyName}</span>{' '}
          {/* Using direct propertyName state */}
        </h1>

        <p className="text-lg font-semibold md:text-base text-gray-800 mb-6">
          Your journey begins here — Reserve, Check-In & Check-Out with ease and comfort
        </p>

        <button
          onClick={handleExploreClick}
          className="px-10 py-3 bg-[#000000] text-white font-bold rounded-md hover:text-gray-400 transition"
        >
          Explore
        </button>
      </div>

      {showLoginModal && <Login closeModal={closeLoginModal} />}
      <ToastContainer />
    </div>
  );
};

export default Home;

// import React, { useState, useEffect } from "react";
// import Cookies from "js-cookie";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import Login from "./LoginPage";

// const BQ_BASE_URL = process.env.REACT_APP_BQ_BASE_URL;

// const fallbackImage =
//   "https://via.placeholder.com/1920x1080?text=Welcome+to+Royal+Garden+Hotel";

// const Home = () => {
//   const [showLoginModal, setShowLoginModal] = useState(false);
//   const [bgMedia, setBgMedia] = useState({ url: "", type: "image" });
//   const [propertyData, setPropertyData] = useState({
//     name: "Pagoda Executive", // Using name instead of propertyname
//   });

//   const closeLoginModal = () => {
//     setShowLoginModal(false);
//     setTimeout(() => {
//       window.location.reload();
//     }, 500);
//   };

//   const handleExploreClick = () => {
//     const token = Cookies.get("access_token");

//     if (!token) {
//       toast.error("You are not logged in. Please log in to continue.", {
//         position: "bottom-right",
//         autoClose: 5000,
//         hideProgressBar: true,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true,
//         theme: "colored",
//       });

//       setTimeout(() => {
//         setShowLoginModal(true);
//       }, 1000);
//     } else {
//       window.location.href = "/check-in/options";
//     }
//   };

//   useEffect(() => {
//     const fetchHomepageData = async () => {
//       const cachedData = localStorage.getItem("homepageData");
//       const cachedTime = localStorage.getItem("homepageDataTimestamp");
//       const oneHour = 60 * 60 * 1000;

//       if (cachedData && cachedTime && Date.now() - cachedTime < oneHour) {
//         const parsedData = JSON.parse(cachedData);
//         setBgMedia(parsedData.media);
//         setPropertyData(parsedData.property);
//         return;
//       }

//       try {
//         const response = await fetch(`${BQ_BASE_URL}/bq/api/properties/1`);
//         if (!response.ok) throw new Error("Failed to fetch property data");
//         const data = await response.json();

//         console.log("API Response:", data); // For debugging

//         // Prepare data for state and storage - using 'name' from API response
//         const mediaData = data.homepage_video_url
//           ? { url: data.homepage_video_url, type: "video" }
//           : data.homepage_url
//           ? { url: data.homepage_url, type: "image" }
//           : { url: fallbackImage, type: "image" };

//         const storageData = {
//           media: mediaData,
//           property: {
//             name: data.name || "Pagoda Hotel", // Using 'name' from API response
//           },
//         };

//         // Update state
//         setBgMedia(mediaData);
//         setPropertyData(storageData.property);

//         // Update localStorage
//         localStorage.setItem("homepageData", JSON.stringify(storageData));
//         localStorage.setItem("homepageDataTimestamp", Date.now().toString());
//       } catch (error) {
//         console.error("Failed to load homepage data", error);
//         if (cachedData) {
//           const parsedData = JSON.parse(cachedData);
//           setBgMedia(parsedData.media);
//           setPropertyData(parsedData.property);
//         } else {
//           setBgMedia({ url: fallbackImage, type: "image" });
//         }
//       }
//     };

//     fetchHomepageData();
//   }, []);

//   return (
//     <div className="relative flex items-center justify-center h-screen w-screen overflow-hidden">
//       {bgMedia.url &&
//         (bgMedia.type === "video" ? (
//           <video
//             src={bgMedia.url}
//             autoPlay
//             loop
//             muted
//             playsInline
//             className="absolute inset-0 w-full h-full object-cover opacity-100"
//           />
//         ) : (
//           <img
//             src={bgMedia.url}
//             alt="Hotel Background"
//             className="absolute inset-0 w-full h-full object-cover opacity-100"
//           />
//         ))}

//       <div className="text-center relative z-10 bg-gray-100 p-7 bg-opacity-70 rounded-lg mt-20">
//         <h1 className="text-xl md:text-3xl font-bold text-gray-950 mb-2">
//           Welcome to{" "}
//           <span className="text-black">{propertyData.name}</span> {/* Using name */}
//         </h1>

//         <p className="text-lg font-semibold md:text-base text-gray-800 mb-6">
//           Your journey begins here — Reserve, Check-In & Check-Out with ease and comfort
//         </p>

//         <button
//           onClick={handleExploreClick}
//           className="px-10 py-3 bg-[#000000] text-white font-bold rounded-md hover:text-gray-400 transition"
//         >
//           Explore
//         </button>
//       </div>

//       {showLoginModal && <Login closeModal={closeLoginModal} />}
//       <ToastContainer />
//     </div>
//   );
// };

// export default Home;
